import { AxiosError } from "axios"

import { InfoBox } from "../InfoBox/InfoBox"

type Props = {
  title?: string
  error: Error | AxiosError | null
}

export const ErrorBox = ({ title, error }: Props) => {
  if (!error) return null

  let message = error.message

  if (error instanceof AxiosError) {
    message += error.response?.data?.message
      ? ` : ${error.response.data.message}`
      : ""
  }

  return <InfoBox title={title} message={message} variant="error" />
}
